import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgTrash = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2 4.85712H22"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1429 2H9.85716C9.47828 2 9.11492 2.15051 8.84701 2.41842C8.5791 2.68633 8.42859 3.04969 8.42859 3.42857V4.85714H15.5714V3.42857C15.5714 3.04969 15.4209 2.68633 15.153 2.41842C14.8851 2.15051 14.5218 2 14.1429 2Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.85718 17V9.85712"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1428 17V9.85712"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5381 20.6895C18.5084 21.0467 18.3456 21.3798 18.0818 21.6225C17.8181 21.8653 17.4727 22 17.1143 22H6.88663C6.52817 22 6.1828 21.8653 5.91905 21.6225C5.6553 21.3798 5.49246 21.0467 5.46282 20.6895L4.14282 4.85712H19.8571L18.5381 20.6895Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgTrash.displayName = 'SvgTrash';
export default SvgTrash;
